import React from 'react';
import { useNavigate } from 'react-router';

import styled from '@emotion/styled';

import { FormSubmitButton } from '../../../components/Button/FormSubmitButton';
import CompanySearchCard from '../../../components/Cards/CompanySearchCard';
import CustomSelectSearchAsyncField from '../../../components/FormCom/CustomSelectSearchAsyncField';
import { FieldControllerSync } from '../../../components/FormCom/FieldControllerSync';
import { FormComponent } from '../../../components/FormCom/FormComponent';
import useCompanyInsight from '../../../hooks/dashboard/companyInsight/useCompanyInsight';
import useCompanySearch from '../../../hooks/dashboard/companyInsight/useCompanySearch';
import {
  CompanyInsightInitialValues,
  CompanyInsightSchema,
} from '../../../models/dashboard/companyInsight/companyInsight';
import { COMPANY_INSIGHTS_SEARCH_RESULTS } from '../../../routes/routeConstants';

const CompanyInsightSearch = () => {
  const [selectedCompany, setSelectedCompany] = React.useState<any>(null);
  const {
    getCompanyInsight,
    loading,
    // companyInsightData
  } = useCompanyInsight();
  const {
    searchCompany,
    loading: searchLoading,
    fetchedCompanyData,
  } = useCompanySearch();
  const navigate = useNavigate();

  const onSubmit = (value: any) => {
    const companyName = value?.name?.trim();
    const companyId = value?.id?.trim();

    if (!companyName || !companyId) return;

    getCompanyInsight(companyName, () =>
      navigate(
        `/${COMPANY_INSIGHTS_SEARCH_RESULTS}/${encodeURIComponent(companyId)}/${encodeURIComponent(companyName)}`,
      ),
    );
  };

  return (
    <Container>
      <Header>Look Up Company History</Header>
      <Description>
        Enter company details to view their professional work history on
        LogiRate
      </Description>
      <FormComponent
        initialValues={CompanyInsightInitialValues}
        schema={CompanyInsightSchema}
        onSubmit={onSubmit}
      >
        <FormRow>
          <CustomSelectSearchAsyncField
            name='name'
            id='name'
            renderComponent={(data) => <CompanySearchCard data={data} />}
            fetchDataFn={(search) => searchCompany(search, false)}
            fetchDataLoading={searchLoading}
            fetchedData={fetchedCompanyData}
            requiredDataKey='name'
            presentationDataKey='name'
            placeholder='Select Company'
            onSelect={(data) => setSelectedCompany(data)}
            showErrorLabel={false}
          />

          <FieldControllerSync
            fieldName='id'
            fieldValue={selectedCompany?.id}
          />
          <FormSubmitButton loading={loading} className='small-padding'>
            Search
          </FormSubmitButton>
        </FormRow>
      </FormComponent>
    </Container>
  );
};

export default CompanyInsightSearch;

const Container = styled.div`
  border: 1px solid ${({ theme }) => theme.palette.borderColor};
  padding: 32px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  border-radius: 5px;
  grid-column: span 3;
`;

const Header = styled.div`
  font-weight: 600;
  font-size: 18px;
  line-height: 18px;
  color: ${({ theme }) => theme.palette.logirateBlack};
`;

const Description = styled.div`
  font-size: 14px;
  line-height: 14px;
  color: ${({ theme }) => theme.palette.grayTextColor};
`;

const FormRow = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 8px;
`;
